<template>
  <div>
    <span class="link-small--dark-60 text-gray-60 flex items-center">
      {{ $t('checkout.tax.alabama.title1') }}
      <i class="md-14 ml-25 cursor-pointer" qaid="alabama-tax-icon" @click="showInfoDialog">info_outline</i>
    </span>

    <el-dialog
      :visible.sync="dialogVisible"
      :title="$t('checkout.tax.alabama.title2')"
      :center="false"
      :modal-append-to-body="true"
      :append-to-body="true"
      :close-on-press-escape="true"
      :close-on-click-modal="true"
      :z-index="16000011"
      :close-dialog-tooltip="$t('popup.close')"
      qaid="alabama-tax-dialog"
    >
      <p class="mb-2">{{ $t('checkout.tax.alabama.body1') }}</p>
      <p>{{ $t('checkout.tax.alabama.body2') }}</p>
    </el-dialog>
  </div>
</template>
<script>
import ElDialog from '../Dialog';

export default {
  name: 'SsutInfoIcon',
  components: {ElDialog},
  data() {
    return {
      dialogVisible: false,
    };
  },
  methods: {
    showInfoDialog() {
      this.dialogVisible = true;
    },
  },
};
</script>
